import { useIM } from '@wui/im'

export function useRoomControl () {
  const roomCall = (pServed: string, audio = false, video = false) => {
    if (!pServed) return Promise.resolve(false)
    return useIM().startConference({
      pServed,
      audio,
      video,
    })
  }

  const roomTerminate = (pServed: string) => {
    if (!pServed) return Promise.resolve(false)
    return useIM().stopConference({
      pServed,
    })
  }

  const roomBeginRecord = (pServed: string) => {
    if (!pServed) return Promise.resolve(false)
    return useIM().beginRecordingConference({
      pServed,
    })
  }

  const roomEndRecord = (pServed: string) => {
    if (!pServed) return Promise.resolve(false)
    return useIM().endRecordingConference({
      pServed,
    })
  }

  const memberCall = (pServed: string, internalNumber: string, enableVideo = false, enableAudio = true) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().callSubscriber({
      pServed,
      internalNumber,
      enableVideo,
      enableAudio,
    })
  }

  const memberKick = (pServed: string, internalNumber: string, callId?: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().kickSubscriber({
      pServed,
      internalNumber,
      callId: callId!,
    })
  }

  const memberMuteAudio = (pServed: string, internalNumber: string, callId?: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().muteSubscriberAudio({
      pServed,
      internalNumber,
      callId: callId!,
    })
  }

  const memberUnmuteAudio = (pServed: string, internalNumber: string, callId?: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().unmuteSubscriberAudio({
      pServed,
      internalNumber,
      callId: callId!,
    })
  }

  const memberMuteVideo = (pServed: string, internalNumber: string, callId?: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().muteSubscriberVideo({
      pServed,
      internalNumber,
      callId: callId!,
    })
  }

  const memberUnmuteVideo = (pServed: string, internalNumber: string, callId?: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().unmuteSubscriberVideo({
      pServed,
      internalNumber,
      callId: callId!,
    })
  }

  const memberHold = (pServed: string, internalNumber: string, callId?: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().holdSubscriber({
      pServed,
      internalNumber,
      callId: callId!,
    })
  }

  const memberUnHold = (pServed: string, internalNumber: string, callId?: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().unholdSubscriber({
      pServed,
      internalNumber,
      callId: callId!,
    })
  }

  const handOn = (pServed: string, internalNumber: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().handRaiseSubscriberHand({
      pServed,
      internalNumber,
    })
  }

  const handOff = (pServed: string, internalNumber: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().handLowerSubscriberHand({
      pServed,
      internalNumber,
    })
  }

  const acceptIncomingCall = (pServed: string, targetNumber: string, callId?: string) => { // Работает только для вызовов с города
    if (!pServed) return Promise.resolve(false)
    return useIM().acceptIncomingCall({
      pServed,
      targetNumber,
      callId: callId!,
    })
  }

  const muteAllAudioExceptExecuter = (pServed: string) => {
    if (!pServed) return Promise.resolve(false)
    return useIM().muteAllAudioExceptExecuter(({
      pServed,
    }))
  }

  const muteAllVideoExceptExecuter = (pServed: string) => {
    if (!pServed) return Promise.resolve(false)
    return useIM().muteAllVideoExceptExecuter(({
      pServed,
    }))
  }

  const pauseConference = (pServed: string, internalNumber: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().holdConference(({
      pServed,
    }))
  }

  const continueConference = (pServed: string, internalNumber: string) => {
    if (!pServed || !internalNumber) return Promise.resolve(false)
    return useIM().unholdConference(({
      pServed,
    }))
  }

  return {
    roomCall,
    roomTerminate,
    roomBeginRecord,
    roomEndRecord,
    memberCall,
    memberKick,
    memberMuteAudio,
    memberUnmuteAudio,
    memberMuteVideo,
    memberUnmuteVideo,
    memberHold,
    memberUnHold,
    handOn,
    handOff,
    acceptIncomingCall,
    muteAllAudioExceptExecuter,
    muteAllVideoExceptExecuter,
    pauseConference,
    continueConference,
  }
}
